// extracted by mini-css-extract-plugin
export var videoContainer = "_iy-0";
export var videoIframe = "_iy-3";
export var videoLink = "_iy-1";
export var videoOverlay = "_iy-4";
export var videoOverlayText = "_iy-5";
export var videoWrapper = "_iy-2";